import { queryOptions } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { IContact } from 'views/DealDashboard/types';

const getCRMDealContactsQueryOptions = (organizationId: string, dealId: number) => queryOptions({
    queryKey: ['CRMDealContacts', organizationId, dealId],
    queryFn: async () => {
        const response = await axiosInstance.get<IContact[]>(
            API_ENDPOINTS.CRM.DEAL_CONTACTS(organizationId, dealId),
        );
        return response.data;
    },
});

export default getCRMDealContactsQueryOptions;
